import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { ToastPortalProps } from './interfaces'

const toastRoot = document.getElementById('toast-root')

export class ToastPortal extends React.Component<ToastPortalProps> {
	toastRootElement: HTMLDivElement

	constructor(props: ToastPortalProps) {
		super(props)
		this.toastRootElement = document.createElement('div')
	}

	componentDidMount(): void {
		if (toastRoot) {
			toastRoot.appendChild(this.toastRootElement)
		}
	}

	componentWillUnmount(): void {
		if (toastRoot) {
			toastRoot.removeChild(this.toastRootElement)
		}
	}

	render(): React.ReactNode {
		return ReactDOM.createPortal(this.props.children, this.toastRootElement)
	}
}
